import { useStoreApi } from '@givebacks/api/store';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { storeKeys } from '../../query-key-factory';

const useDeleteStoreItem = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const deleteStoreItem = async ({ causeId, uuid }: { causeId: string; uuid: string }) => {
    const { data } = await StoreApi.delete(`/store_items/${uuid}?cause_id=${causeId}`);
    return data;
  };

  return useMutation({
    mutationFn: deleteStoreItem,
    onSuccess(_, variables) {
      const { causeId } = variables;
      const key = storeKeys.id(causeId).items.all;
      void queryClient.invalidateQueries({ queryKey: key });
    },
  });
};

export { useDeleteStoreItem };
